import { OpenAIEmbeddings } from "langchain/embeddings/openai";
// import { similaritySearch } from "langchain/VectorStore/similaritySearch";
import { VectorStore } from "langchain/vectorstores/base";

const apiKey = process.env.OPENAI_KEY;
// const embeddings = new OpenAIEmbeddings({ openAIApiKey: apiKey });
const embeddings = new OpenAIEmbeddings({openAIApiKey: "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"
});

export async function embed(text) {
  const vector = await embeddings.embedQuery(text);

  // Save the vector in web browser memory
  const vectorJSON = JSON.stringify(vector);
  localStorage.setItem("vector", vectorJSON);
  localStorage.setItem("vectorPure", vector);
}

// retrieve and search query
export async function queryVectorStore(queryText, k = 5) {
  // Create an instance of VectorStore
  const vectorStore = new VectorStore(embeddings);

  const storedVectorStore = JSON.parse(localStorage.getItem("vector"));
  const storedVectorStore2 = localStorage.getItem("vectorPure");
  console.log("I am stored vector", storedVectorStore[0]);

  console.log("I am stored vector2", storedVectorStore2[0]);

  // Check if storedVectorStore exists and has the item
  if (storedVectorStore) {
    // && storedVectorStore2.hasOwnProperty("itemKey")) {
    // Perform the similarity search
    const queryVector = await embeddings.embedQuery(queryText);
    console.log("I am query vector", queryVector);
    // await vectorStore.addVectors([storedVectorStore]);

    const documentVectors = [queryVector];


    // const similarities = documentVectors.map((vector) =>
    //   cosineSimilarity(queryVector, vector)
    // );
    // const sortedDocuments = documents.sort(
    //   (a, b) =>
    //     similarities[documents.indexOf(b)] - similarities[documents.indexOf(a)]
    // );
    // return sortedDocuments;


const similarities = documentVectors.map((vector) =>
  cosineSimilarity(queryVector, vector)
);
const sortedSimilarities = similarities.slice().sort((a, b) => b - a); // Sort similarities in descending order
return sortedSimilarities;

    return await storedVectorStore2.similaritySearch(queryVector, k);
  } else {
    // Item not found in local storage
    console.log("Nothing in storage yet. First upload PDF!");
    return null;
  }
}

function cosineSimilarity(a, b) {
  const dotProduct = a.reduce((acc, val, i) => acc + val * b[i], 0);
  const magnitudeA = Math.sqrt(a.reduce((acc, val) => acc + val * val, 0));
  const magnitudeB = Math.sqrt(b.reduce((acc, val) => acc + val * val, 0));
  return dotProduct / (magnitudeA * magnitudeB);
}
